import { Base } from "@/components/General/Image/components/base";
import { Img } from "@/components/General/Image/components/img";

export const Image = Object.assign(Base, {
    Img: Img
});
